export default __webpack_public_path__ + "static/media/87.6fdcf607.png";